import { userData } from '../../../util/userData';

export function redirectToUrl(page, display?) {
  if (!display) {
    display = page.replace('', '');
    if (display.indexOf('?') > -1)
      display = display.substring(0, display.indexOf('?'));
    display = display.replace(/_/g, " ");
  }

  appendToBreadCrumb(page, display);
  window.location = page;
}

function appendToBreadCrumb(page, display) {
  var pages = getBreadCrumbsArray();

  display.replace('#', '');
  display.replace('!', '');

  if (display === 'coachingoverview')
    display = 'coaching overview';
  if (display === 'commentdetails')
    display = 'comment details';
  if (display === 'coachingform')
    display = 'coaching form';

  var newPage = {
    display: display,
    url: page
  };

  if (!verifyBcNotInList(pages, newPage)) {
    pages.push(newPage);
  }
  // @ts-ignore
  userData.storeUserDataInSession('bc', pages);
}

function verifyBcNotInList(list, np) {
  var npUrl = np.url && np.url.replace('/', '');

  return list.some(function (page) {
    var pageUrl = page.url && page.url.replace('/', '');

    return npUrl && pageUrl && npUrl === pageUrl
  });
}

function getBreadCrumbsArray(clearPreviousCrumbs?) {
  return initBreadCrumbsArray(clearPreviousCrumbs);
}

function initBreadCrumbsArray(forceInit?) {
  var pages = userData.getUserDataFromSession('bc');
  var shouldInitialize = pages === null || forceInit;
  var isHomePage = function (page) {
    return page.display === 'HOME'
  };
  var homePage = Array.isArray(pages) && pages.filter(isHomePage).pop();
  var pathname = location.pathname;
  var isLoginPage = pathname.indexOf('login') >= 0 || pathname.indexOf('login.html') >= 0;

  if (isLoginPage) {
    return [];
  }

  if (shouldInitialize) {
    pages = [];

    if (homePage) {
      pages.push(homePage);
    } else {
      var defaultPage = userData.getUserDataFromSession('defaultPage') || location.pathname;
      pages.push({
        display: 'HOME',
        url: defaultPage
      });
    }

    // @ts-ignore
    userData.storeUserDataInSession('bc', pages);
  } else {
    //if current page is in breakcrumbs pop pages array
    //until we are back at the current page
    var currentPathInBreadCrumbs = pages.some(function (page) {
      return pathname.indexOf(page.url) >= 0
    });

    if (currentPathInBreadCrumbs) {
      for (var i = pages.length - 1; i >= 0; i--) {
        if (pathname.indexOf(pages[i].url) >= 0) {
          break;
        }

        pages.pop();
      }

      // @ts-ignore
      userData.storeUserDataInSession('bc', pages);
    }
  }

  return pages;
}

export const filterUsers = (
  users,
  searchUsernameNeedle,
  isCurrentProjectChecked
) => {
  let filteredUsers = [];
  filteredUsers = users.filter((user) => {
    if (isCurrentProjectChecked) {
      if (user.isUserInCurrentProject) {
        if (
          searchUsernameNeedle.length > 0 &&
          user.username.toLowerCase().includes(searchUsernameNeedle.toLowerCase())
        )
          return true;
        else return searchUsernameNeedle.length === 0;
      }
    } else {
      if (
        searchUsernameNeedle.length > 0 &&
        user.username.toLowerCase().includes(searchUsernameNeedle.toLowerCase())
      )
        return true;
      else return searchUsernameNeedle.length === 0;
    }
  });

  return filteredUsers;
};
